'use client';
import React from 'react';
import { useParams } from 'next/navigation';
import cn from './style.module.scss';

export default function GardeniaLogo(props: any) {
  const { lang } = useParams();
  const logoImage = lang === 'ar' ? props.logoImage.ar : props.logoImage.en;
  return (
    <div className={cn.brandGRDLogo}>
      <img alt={logoImage?.url} src={logoImage?.url} />
    </div>
  );
}
